import React from "react";
import { Jumbotron } from "react-bootstrap";
import "./index.css";

const Schedule = () => {
  return (
    <div>
      <Jumbotron
        style={{ margin: 0, backgroundColor: "#03fcc6", borderRadius: 0 }}
      >
        <div style={{ textAlign: "center" }}>
          <h1>
            <b>
              OUR CLASSES ARE STARTING! Sign up{" "}
              <a
                className="link"
                rel="noopener noreferrer"
                target="_blank"
                href="https://forms.gle/SmfRoMDZFdMUaxq88"
              >
                here
              </a>
              .
            </b>
          </h1>
          <ul>
            <li>
              Base Plan: $20 for one subject for a month (four classes offered)
            </li>
            <li>Bundle #1: $70 for all subjects for a month</li>
            <li>
              Bundle #2: $200 for all subjects for the entire summer (June -
              August)
            </li>
          </ul>
        </div>
      </Jumbotron>
      <Jumbotron
        style={{ margin: 0, backgroundColor: "#ed9166", borderRadius: 0 }}
      >
        <div style={{ textAlign: "center" }}>
          Lessons are 1 hour each.
          <ul>
            <li>History is taught on Mondays,</li>
            <li>Science is taught on Tuesdays,</li>
            <li>Math is taught on Wednesdays,</li>
            <li>and Chess is taught on Thursdays.</li>
          </ul>
        </div>
      </Jumbotron>
    </div>
  );
};

export default Schedule;